import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';
import { BaseModalComponent } from '../base-modal.component';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.css'],
  standalone: false
})
export class InfoModalComponent extends BaseModalComponent {
  public info = '';
  renderAsHtml = false;
  title = 'Information';
  showIcon = true;
  buttonText = 'Cancel';
  footerText = '';

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {
    super(activeModal);
  }

  closeModal(): void {
    console.log('Closing Modal...');
    this.activeModal.close(true);
  }
}

LightningModalTypes.InfoModalComponent.component = InfoModalComponent;
